export default __webpack_public_path__ + "static/media/SEGOEUIB.bb81983d.TTF";